function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from 'react';
import styles from './IntegrationPanel.module.scss';
import Logo from '../icons/logos/Nightbot';
import classNames from 'classnames';
import Icon, { IconSizes } from '../Icon';
import { AnimatePresence, motion, useInView } from 'framer-motion';
import { useDebounce } from 'use-debounce';
import { faDiscord, faSquareJs, faTwitch, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { v4 as uuidv4 } from 'uuid';
import NoiceIconFilled from '../icons/logos/NoiceFilled';
import API from '../icons/lord/API';
import { LordIconSizes } from '@/types/client';
import TrovoIcon from '../icons/logos/Trovo';
import SoopIcon from '../icons/logos/Soop';
import { faBullhorn, faMagicWandSparkles, faShieldHalved, faUserClock } from '@fortawesome/free-solid-svg-icons';
var PLATFORM_ICONS = [
    {
        id: uuidv4(),
        icon: /*#__PURE__*/ _jsx(Icon, {
            icon: faYoutube,
            size: IconSizes.LG
        }),
        className: styles.youtubeIcon
    },
    {
        id: uuidv4(),
        icon: /*#__PURE__*/ _jsx(Icon, {
            icon: faDiscord,
            size: IconSizes.LG
        }),
        className: styles.discordIcon
    },
    {
        id: uuidv4(),
        icon: /*#__PURE__*/ _jsx(NoiceIconFilled, {
            className: styles.noiceLogo
        }),
        className: styles.noiceIcon
    },
    {
        id: uuidv4(),
        icon: /*#__PURE__*/ _jsx(Icon, {
            icon: faTwitch,
            className: styles.twitchIcon
        }),
        className: styles.twitchIconContainer
    },
    {
        id: uuidv4(),
        icon: /*#__PURE__*/ _jsx(TrovoIcon, {
            className: styles.trovoLogo
        }),
        className: styles.trovoIconContainer
    },
    {
        id: uuidv4(),
        icon: /*#__PURE__*/ _jsx(SoopIcon, {
            className: styles.soopLogo
        }),
        className: styles.soopIconContainer
    }
];
var PROVIDER_ICONS = [
    {
        id: uuidv4(),
        icon: /*#__PURE__*/ _jsx(Icon, {
            icon: faSquareJs,
            size: IconSizes.LG
        }),
        className: styles.providerIconContainer
    },
    {
        id: uuidv4(),
        icon: /*#__PURE__*/ _jsx(API, {
            size: LordIconSizes.MEDIUM
        }),
        className: styles.providerIconContainer
    },
    {
        id: uuidv4(),
        icon: /*#__PURE__*/ _jsx(Icon, {
            icon: faShieldHalved,
            className: styles.shieldIcon
        }),
        className: styles.providerIconContainer
    },
    {
        id: uuidv4(),
        icon: /*#__PURE__*/ _jsx(Icon, {
            icon: faMagicWandSparkles,
            className: styles.wandIcon
        }),
        className: styles.providerIconContainer
    },
    {
        id: uuidv4(),
        icon: /*#__PURE__*/ _jsx(Icon, {
            icon: faUserClock,
            className: styles.userClockIcon
        }),
        className: styles.providerIconContainer
    },
    {
        id: uuidv4(),
        icon: /*#__PURE__*/ _jsx(Icon, {
            icon: faBullhorn,
            className: styles.bullhornIcon
        }),
        className: styles.providerIconContainer
    }
];
var INTERVAL = 1000; // 1 seconds
export default function IntegrationPanel(_param) {
    var className = _param.className, props = _object_without_properties(_param, [
        "className"
    ]);
    var ref = useRef(null);
    var inView = useInView(ref);
    var _useState = _sliced_to_array(useState(0), 2), animationCount = _useState[0], setAnimationCount = _useState[1];
    var _useDebounce = _sliced_to_array(useDebounce(inView, 500), 1), debouncedInView = _useDebounce[0];
    var _React_useState = _sliced_to_array(React.useState(false), 2), isVisible = _React_useState[0], setIsVisible = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(PLATFORM_ICONS[Math.floor(Math.random() * PLATFORM_ICONS.length)]), 2), platformIcon = _React_useState1[0], setPlatformIcon = _React_useState1[1];
    var _React_useState2 = _sliced_to_array(React.useState(PROVIDER_ICONS[Math.floor(Math.random() * PROVIDER_ICONS.length)]), 2), providerIcon = _React_useState2[0], setProviderIcon = _React_useState2[1];
    var updateIconsRandomly = React.useCallback(function() {
        var newPlatformIconIndex = Math.floor(Math.random() * PLATFORM_ICONS.length);
        var newProviderIconIndex = Math.floor(Math.random() * PROVIDER_ICONS.length);
        setPlatformIcon(function(prev) {
            if (PLATFORM_ICONS[newPlatformIconIndex].id === prev.id) {
                return PLATFORM_ICONS[(newPlatformIconIndex + 1) % PLATFORM_ICONS.length];
            }
            return PLATFORM_ICONS[newPlatformIconIndex];
        });
        setProviderIcon(function(prev) {
            if (PROVIDER_ICONS[newProviderIconIndex].id === prev.id) {
                return PROVIDER_ICONS[(newProviderIconIndex + 1) % PROVIDER_ICONS.length];
            }
            return PROVIDER_ICONS[newProviderIconIndex];
        });
    }, []);
    React.useEffect(function() {
        if (animationCount % 3 === 0) {
            updateIconsRandomly();
        }
    }, [
        animationCount,
        updateIconsRandomly
    ]);
    React.useEffect(function() {
        if (!debouncedInView || !isVisible) {
            return;
        }
        setAnimationCount(function(prev) {
            return prev + 1;
        });
        var interval = setInterval(function() {
            return setAnimationCount(function(prev) {
                return prev + 1;
            });
        }, INTERVAL);
        return function() {
            return clearInterval(interval);
        };
    }, [
        debouncedInView,
        isVisible
    ]);
    React.useEffect(function() {
        var handleVisibilityChange = function() {
            return setIsVisible(document.visibilityState === 'visible');
        };
        handleVisibilityChange();
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return function() {
            return document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
        ref: ref,
        className: classNames(styles.integrationPanel, className)
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: classNames(_define_property({}, styles.integrationPanelAnimation, animationCount % 3 === 1), styles.integrationPanelContainer)
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.integrationPanel,
                children: [
                    /*#__PURE__*/ _jsx(AnimatePresence, {
                        initial: false,
                        mode: "popLayout",
                        children: /*#__PURE__*/ _jsx(motion.div, {
                            transition: {
                                y: {
                                    duration: 0.75,
                                    type: 'spring',
                                    stiffness: 100,
                                    damping: 10
                                }
                            },
                            initial: {
                                y: 40,
                                opacity: 0
                            },
                            animate: {
                                y: 0,
                                opacity: 1
                            },
                            exit: {
                                y: -40,
                                opacity: 0
                            },
                            className: classNames(styles.providerIcon, providerIcon.className),
                            children: providerIcon.icon
                        }, providerIcon.id)
                    }),
                    /*#__PURE__*/ _jsx(Logo, {
                        className: styles.logo
                    }, "logo"),
                    /*#__PURE__*/ _jsx(AnimatePresence, {
                        initial: false,
                        mode: "popLayout",
                        children: /*#__PURE__*/ _jsx(motion.div, {
                            transition: {
                                y: {
                                    duration: 0.75,
                                    type: 'spring',
                                    stiffness: 100,
                                    damping: 10
                                }
                            },
                            initial: {
                                y: -40,
                                opacity: 0
                            },
                            animate: {
                                y: 0,
                                opacity: 1
                            },
                            exit: {
                                y: 40,
                                opacity: 0
                            },
                            className: classNames(styles.platformIcon, platformIcon.className),
                            children: platformIcon.icon
                        }, platformIcon.id)
                    })
                ]
            })
        ]
    }));
}
